import React from 'react';
import { TravelExpensesFormQuery } from 'api/services/TravelExpenses';
import { columns } from './OverViewTableModels';
import { Box, Heading } from '@chakra-ui/react';
import { Alert } from 'components/Alert/Alert';
import { Table } from '@landsvirkjun/react.common';
import { NoData } from 'components/NoData/NoData';
import { Spinner } from 'components/Spinner';

type TravelExpensesTableOverviewProps = {
  isError: boolean;
  isFetching: boolean;
  data: TravelExpensesFormQuery[];
  noDataText: string;
  handleDeleteAttachment: (doc: string | undefined, lineId: string) => void;
  handleDeleteCostLine: (lineId: string | undefined) => void;
  isDeletingAttachment: boolean;
};
export const TravelExpensesTableOverview = ({
  isError,
  isFetching,
  noDataText,
  data,
  handleDeleteAttachment,
  handleDeleteCostLine,
  isDeletingAttachment,
}: TravelExpensesTableOverviewProps): JSX.Element => {
  if (isError) {
    return (
      <Box as="div" mt={10}>
        <Alert
          errorText="Ekki tókst að sækja kostnaðarliði fyrir tiltekna beiðni"
          status="error"
        />
      </Box>
    );
  }

  const reversedDataOrder = [...data].reverse();

  return (
    <Box as="div" mt={10}>
      <Heading size={'md'}>Kostnaðarliðir</Heading>
      {isFetching ? (
        <Spinner delay={300} isFixed={false} />
      ) : data.length > 0 ? (
        <Table
          data={reversedDataOrder}
          columns={columns(
            handleDeleteAttachment,
            isDeletingAttachment,
            handleDeleteCostLine
          )}
        />
      ) : (
        <NoData text={noDataText} />
      )}
    </Box>
  );
};
